const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
export const quotationConfirm = {
  name: "",
  collectFrom: [],
  deliverTo: [],
  // details: [],
  services: [],
  comments: "",
  movingDate: { date: "", status: 'awaiting' },
  packingDate: { date: "", status: 'awaiting' },
  isAcceptLiabilityCover: false,
  liabilityCover: "",
  isTerm: false,
  isAccepted: false,
  isSubmitted: false,
  thankYouMessage: "",
  termLink: "",
};

export const confirmationDetails = [
  // {
  //   id: "details",
  //   label: "",
  //   type: "title",
  //   md: 4,
  // },
  // {
  //   id: "name",
  //   label: "Name",
  //   placeHolder: "",
  //   type: "labelWithValue",
  //   // isRequired: true,

  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
  // {
  //   id: "details",
  //   label: "",
  //   type: "title",
  //   md: 4,
  // },
  {
    id: "collectFrom",
    label: "",
    placeHolder: "",
    type: "labelWithValue",
    // isRequired: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "details",
    label: "Details",
    type: "title",
    md: 4,
  },
  {
    id: "deliveryTo",
    label: "",
    placeHolder: "",
    type: "labelWithValue",
    // isRequired: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

// Improved validation function
export const confirmationValidateForm = (formData: any) => {
  let isError = false;
  const localError: any = {};

  // Validate services
  formData?.services.forEach((service: any, index: any) => {
    // Check if both status and cost are provided
    if (!service?.status && (!service?.cost || service?.cost !==0)) {
      return; // Skip validation for empty service entries
    }
    // If status or cost is missing, flag an error
    if (!(service?.status && (service?.cost || service?.cost ===0))) {
      isError = true;
      if (!localError.services) {
        localError.services = {};
      }
      localError.services[index] = {
        status: !service?.status ? "Please select a status" : "",
        cost: !service?.cost || service?.cost !==0 ? "Please provide a cost" : "",
      };
    }
  });

  // Validate other fields like movingDate, packingDate, etc.
  if (!(formData?.movingDate?.status)) {
    isError = true;
    localError.movingDate = {
      // date: "Moving date is required",
      status: "Moving status is required",
    };
    // localError.movingDate = { status: "Moving status is required" };
  }

  if (!( formData?.packingDate?.status)) {
    isError = true;
    localError.packingDate = {
      // date: "Packing date is required",
      status: "Packing status is required",
    };
    // localError.packingDate = { status: "Packing status is required" };
  }

  if(!(formData?.isAccepted)){
  isError = true;
  localError.isAccepted = "Please accept the above details";
  }
  if(!formData?.isTerm){
    isError = true;
    localError.isTerm = "Please accept the terms and conditions";
  }

    // Check if liabilityCover is required
    if (formData.isAcceptLiabilityCover === null && !formData.liabilityCover) {
      isError = true;
      localError.liabilityCover = "Liability cover is required";
    }

    // if(!formData?.comments){
    //   isError = true;
    //   localError.comments = "Please enter comments";
    // }
  

  return { isError, localError };
};

export const clientInsuranceGeneralFields=[

  {
    id: "insurancePercentage",
    label: "Insurance (%)",
    placeHolder: "",
    type: "text",
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    valueFormat: 'number',
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
 
]
export const clientInsuranceFields=[

  {
    id: "insuranceAmount",
    label: "Insurance Amount",
    placeHolder: "",
    type: "text",
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: 'number',
    prefixIcon:'£',
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "insuranceType",
    label: "Insurance Type",
    placeHolder: "",
    type: "text",
    disabled: true,
     options:["Move Price", "Contents", "Pack Price", "In to store", "From store", "Fixed", 'Bronze Ext Liability', 'Silver Ext Liability', 'Gold Ext Liability'],
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "isInsuranceAccepted",
    label: "Insurance Status",
    placeHolder: "Select",
    type: "radio",
    row: true,
    md: 4,
    radioOptions: [
      {
        label: "Accept",
        value: true,
      },
      {
        label: "Decline",
        value: false,
      },
      
    ],
  },
]

export const clientQuoteTotalFields=[

  {
    id: "quoteTotal",
    label: "Quote Total",
    placeHolder: "",
    type: "text",
    // md: 4,
    inputProps: {
      maxLength: 50,
    },
    disabled: true,
    valueFormat: 'number',
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

]

export const customerDetailsName = [
  {
    name1: "Pace: Dwelling to Vehicles",
    name2: "External Flight of Stairs",
    name3: "Property Style",
    name4: "Bedrooms",
    name5: "Levels",
    name6: "Purchase Status",
  },
  // {
  //   name: "External Flight of Stairs",
  // },
  // {
  //   name: "Property Style",
  // },
  // {
  //   name: "Bedrooms",
  // },
  // {
  //   name: "Levels",
  // },
  // {
  //   name: "Purchase Status",
  // }
]
